export const DEFAULT_SPACE = 'medium'
